<template>
  <div>
    <div class="mb-4 post-border-c">
      <modal
        hide-footer
        :show.sync="editModalPopup"
        header-classes="bg-primary p-3 cust-opacfull"
      >
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT POST DETAILS
        </h6>
        <div class="mb-4">
          <label>Edit Caption</label>
          <div>
            <b-input
              placeholder="Type a question"
              @change="(abc) => (text = abc)"
              :value="item.text"
              class="form-control-muted"
            />
          </div>
        </div>
        <template slot="footer" class="flex justify-center">
          <base-button @click="save()" type="primary">SAVE CHANGES</base-button>
        </template>

        <!-- <EditDetailPopup :item="item" /> -->
      </modal>
      <!-- <modal
      :show.sync="editModal"
      header-classes="bg-primary p-3"
      footer-classes="p-0"
      size=""
    >
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        RE-POST
      </h6>
      <div slot="footer"></div>
      <RePost />
    </modal> -->
      <modal
        :show.sync="editModal"
        header-classes="py-4 px-6"
        size="lg"
        hide-footer
        footerClasses="hidden"
      >
        <h6 slot="header" class="text-2xl font-semibold pt-1">Reactions</h6>
        <b-card no-body class="mt-2 border-0">
          <b-tabs card class="cust-mdl-p-0 border-0" justified>
            <b-tab
              active
              class="cust-overflow-y-primary-color-grey tab-cnt-ht"
              title-item-class="px-1 tab-style"
              @click="getLikeUsers('all')"
            >
              <template #title>
                <div class="flex items-center">
                  <p class="ml-1.5 pt-0.5">All {{ item.totalLikes }}</p>
                </div>
              </template>
              <User
                :users="users"
                @getLikeUsers="getLikeUsers('all')"
                :showLoadMore="item.totalLikes > users.length"
              />
            </b-tab>
            <b-tab
              class="cust-overflow-y-primary-color-grey tab-cnt-ht"
              title-item-class="px-1 tab-style"
              @click="getLikeUsers('like')"
            >
              <template #title>
                <div class="flex items-center">
                  <img src="../img/thumb.jpg" alt="Like" class="h-4" />
                  <p class="ml-1.5 pt-0.5">{{ thumblikes }}</p>
                </div>
              </template>
              <User
                :users="users"
                @getLikeUsers="getLikeUsers('like')"
                :showLoadMore="thumblikes > users.length"
              />
            </b-tab>
            <b-tab
              class="cust-overflow-y-primary-color-grey tab-cnt-ht"
              title-item-class="px-1 tab-style"
              @click="getLikeUsers('celebrate')"
            >
              <template #title>
                <div class="flex items-center">
                  <img src="../img/clapping.jpg" alt="Like" class="h-4" />
                  <p class="ml-1.5 pt-0.5">{{ celebratelikes }}</p>
                </div>
              </template>
              <User
                :users="users"
                @getLikeUsers="getLikeUsers('celebrate')"
                :showLoadMore="celebratelikes > users.length"
              />
            </b-tab>
            <b-tab
              class="cust-overflow-y-primary-color-grey tab-cnt-ht"
              title-item-class="px-1 tab-style"
              @click="getLikeUsers('support')"
            >
              <template #title>
                <div class="flex items-center">
                  <img src="../img/support.jpg" alt="Like" class="h-4" />
                  <p class="ml-1.5 pt-0.5">{{ supportlikes }}</p>
                </div>
              </template>
              <User
                :users="users"
                @getLikeUsers="getLikeUsers('support')"
                :showLoadMore="supportlikes > users.length"
              />
            </b-tab>
            <b-tab
              class="cust-overflow-y-primary-color-grey tab-cnt-ht"
              title-item-class="px-1 tab-style"
              @click="getLikeUsers('love')"
            >
              <template #title>
                <div class="flex items-center">
                  <img src="../img/heart.jpg" alt="Like" class="h-4" />
                  <p class="ml-1.5 pt-0.5">{{ lovelikes }}</p>
                </div>
              </template>
              <User
                :users="users"
                @getLikeUsers="getLikeUsers('love')"
                :showLoadMore="lovelikes > users.length"
              />
            </b-tab>
            <b-tab
              class="cust-overflow-y-primary-color-grey tab-cnt-ht"
              title-item-class="px-1 tab-style"
              @click="getLikeUsers('insightful')"
            >
              <template #title>
                <div class="flex items-center">
                  <img src="../img/lamp.jpg" alt="Like" class="h-4" />
                  <p class="ml-1.5 pt-0.5">{{ insightfullikes }}</p>
                </div>
              </template>
              <User
                :users="users"
                @getLikeUsers="getLikeUsers('insightful')"
                :showLoadMore="insightfullikes > users.length"
              />
            </b-tab>
            <b-tab
              class="cust-overflow-y-primary-color-grey tab-cnt-ht"
              title-item-class="px-1 tab-style"
              @click="getLikeUsers('curios')"
            >
              <template #title>
                <div class="flex items-center">
                  <img src="../img/curios.jpg" alt="Like" class="h-4" />
                  <p class="ml-1.5 pt-0.5">{{ curioslikes }}</p>
                </div>
              </template>
              <User
                :users="users"
                @getLikeUsers="getLikeUsers('curios')"
                :showLoadMore="curioslikes > users.length"
              />
            </b-tab>
          </b-tabs>
        </b-card>

        <template slot="footer">
          <div class="hidden"></div>
        </template>
      </modal>
      <b-card
        no-body
        class="border-none md:px-6 lg:px-6 px-4 pt-6 bg-white rounded-xl"
      >
        <div class="flex justify-between mb-4">
          <div class="flex items-center">
            <img
              alt="user"
              class="rounded-full w-8 h-8"
              :src="`${$imageURL}/${item._profile.image}`"
              v-if="
                item._profile.hasOwnProperty('image') &&
                item._profile.image !== 'null' &&
                item._profile.image !== '' &&
                item._profile.image !== null
              "
            />
            <b-avatar
              v-else
              variant="info "
              class="p-2 text-xl cust-avatar"
              size="lg"
            ></b-avatar>

            <div class="ml-4">
              <h4 class="font-semibold">{{ name }}</h4>
              <p class="text-muted text-xs font-normal">{{ postTime }}</p>
            </div>
          </div>
          <div class="flex">
            <!-- <feather-icon
              icon="BookmarkIcon"
              class="text-black cursor-pointer mr-4"
              :svgClasses="{
                'fill-current stroke-current': item.isSaved,
              }"
              @click="savePost(item._id)"
            ></feather-icon> -->
            <!-- <feather-icon
              icon="MoreHorizontalIcon"
              class="text-black cursor-pointer"
            ></feather-icon> -->
            <b-dropdown
              v-if="userData._id == item._user.id || userData.role == 'admin'"
              size="lg"
              variant="link"
              toggle-class="text-decoration-none py-2 px-2 text-black cursor-pointer cust-drop"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  class="cursor-pointer text-black"
                  icon="MoreHorizontalIcon"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </template>

              <b-dropdown-item @click="showSwal(item._id)"
                >Delete</b-dropdown-item
              >
              <b-dropdown-item
                v-if="item.type !== 'poll'"
                @click="editModalPopup = true"
                >Edit
              </b-dropdown-item>
              <b-dropdown-item @click="reportPost(item._id)"
                >Report</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="md:mt-2 lg:mt-2 mt-0">
          <p
            class="md:text-base lg:text-base text-sm darktext font-normal md:mt-2 lg:mt-2 mt-0"
          >
            {{ item.text }}
          </p>
          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'image'">
            <img alt="postimage" class="rounded-lg postimght" :src="image" />
          </div>
          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'video'">
            <video controls :src="image"></video>
          </div>
          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'audio'">
            <audio controls :src="image"></audio>
          </div>
          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'poll'">
            <Poll :data="item" />
          </div>
          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'url'">
            <link-prevue
              :apiUrl="$apiUrl + '/post/urlParser'"
              :url="item.url"
            ></link-prevue>
          </div>
          <div class="reactions flex my-4">
            <div class="flex items-center cursor-pointer" @click="LikeCounts()">
              <img src="../img/thumb.jpg" alt="like" class="w-4 h-4 my-auto" />
              <img
                src="../img/clapping.jpg"
                alt="like"
                class="w-4 h-4 my-auto mx-1"
              />
              <img src="../img/heart.jpg" alt="like" class="w-4 h-4 my-auto" />
            </div>
            <small class="ml-6">{{ item.totalLikes }}</small>
            <small class="mx-2">|</small>
            <small class=""
              >{{ item.totalComments }}
              {{ item.totalComments > 1 ? "Comments" : "Comment" }}</small
            >
          </div>
          <div class="border-t-2 my-4">
            <div class="flex my-4">
              <div class="w-1/2 flex justify-center">
                <LikePost
                  :postId="item._id"
                  :isLiked="!!item.isLiked.length"
                  :likeType="!!item.isLiked.length ? item.isLiked[0].type : ''"
                />Like
              </div>
              <div
                class="w-1/2 flex justify-center cursor-pointer"
                @click="toggle = !toggle"
              >
                <feather-icon
                  icon="MessageCircleIcon"
                  class="mr-1"
                ></feather-icon
                >Comment
              </div>
              <!-- <div class="w-1/3 flex justify-center">
                <feather-icon icon="SendIcon" class="mr-1"></feather-icon>Share
              </div> -->
            </div>
          </div>

          <div v-show="toggle">
            <Comment :postId="item._id" :data="item" />
            <!-- v-if="item.type !== 'poll'" -->
          </div>
        </div>
      </b-card>
    </div>
  </div>
  <!-- <div class="icons flex my-4" v-if="item.type !== 'poll'"> -->
  <!-- <div>
            <feather-icon
              icon="HeartIcon"
              class="cursor-pointer mr-4"
              :svgClasses="{
                'text-danger fill-current stroke-current': !!item.isLiked
                  .length,
                'w-6': true
              }"
              @click="likeUnlikePost(item._id, !!item.isLiked.length)"
            ></feather-icon>
            <small class="">Like</small>
          </div> -->
  <!-- <LikePost />
          <feather-icon
            icon="Share2Icon"
            class="cursor-pointer mr-4"
            svgClasses="w-6"
          ></feather-icon> -->
  <!-- <feather-icon
            @click="editModal = true"
            icon="NavigationIcon"
            class="cursor-pointer mr-4"
            svgClasses="w-6"
          ></feather-icon> -->
  <!-- </div> -->
</template>

<script>
import EditDetailPopup from "./EditDetailPopup.vue";
import RePost from "./RePost.vue";
import LinkPrevue from "link-prevue";
import Poll from "./Poll.vue";
import FeatherIcon from "../../../components/FeatherIcon.vue";
import User from "./User.vue";
import Comment from "./Comment.vue";
import LikePost from "./LikePost.vue";
import { mapState } from "vuex";
export default {
  components: {
    FeatherIcon,
    Comment,
    Poll,
    LinkPrevue,
    LikePost,
    User,
    EditDetailPopup,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggle: false,
      editModal: false,
      text: this.text,
      editModalPopup: false,
      thumblikes: 0,
      lovelikes: 0,
      celebratelikes: 0,
      supportlikes: 0,
      insightfullikes: 0,
      curioslikes: 0,
      users: [],
      limit: 10,
      offset: 0,
      type: "",
    };
  },

  methods: {
    async save() {
      this.editModalPopup = false;
      // console.log(this.item);

      await this.$store.dispatch("posts/UserEditPost", {
        _id: this.item._id,
        text: this.text,
      });
      this.$store.dispatch("posts/getChannelPosts", this.selectedChannel._id);
    },
    async likeUnlikePost(postId, isLiked) {
      let loader = this.$loading();
      try {
        if (isLiked) {
          let unLike = {
            postId: postId,
          };

          await this.$store.dispatch("posts/unlikePost", unLike);
        } else {
          let Like = {
            type: "like",
            postId: postId,
          };

          await this.$store.dispatch("posts/likePost", Like);
        }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    showSwal(postID) {
      this.$swal({
        title: `Are you sure`,
        text: "Do you want to delete?",
        // buttonsStyling: false,
        showCancelButton: true,
        cancelButtonColor: "",
        confirmButtonClass: "btn btn-primary bg-primary",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "OK",
        cancelButtonText: "No",
        icon: "warning",
      }).then(async (result) => {
        if (result.value) {
          let data = await this.$store.dispatch("posts/deletePost", { postID });
          // console.log(data);
          if (data.code === 200) {
            this.$swal(
              "Deleted!",
              "Post has been successfully deleted",
              "success"
            );
            await this.$store.dispatch(
              "posts/getChannelPosts",
              this.selectedChannel._id
            );
          } else {
            await this.$store.dispatch(
              "posts/getChannelPosts",
              this.selectedChannel._id
            );
          }
        }
      });
    },
    reportPost(postID) {
      this.$swal({
        title: `Are you sure`,
        text: "Do you want to report this post?",
        // buttonsStyling: false,
        showCancelButton: true,
        cancelButtonColor: "",
        confirmButtonClass: "btn btn-primary bg-primary",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "OK",
        cancelButtonText: "No",
        icon: "warning",
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch("posts/UserEditPost", {
            _id: this.item._id,
            reported: "yes",
          });
          this.$store.dispatch(
            "posts/getChannelPosts",
            this.selectedChannel._id
          );
          // console.log(data);
          if (data.code === 200) {
            this.$swal("Reported!", "Post has been reported", "success");
            await this.$store.dispatch(
              "posts/getChannelPosts",
              this.selectedChannel._id
            );
          } else {
            await this.$store.dispatch(
              "posts/getChannelPosts",
              this.selectedChannel._id
            );
          }
        }
      });
    },
    async savePost(postId) {
      if (this.item.isSaved) {
        await this.$store.dispatch("posts/unsavePost", { postId });
        // await this.$store.dispatch(
        //   "posts/setUserChannelFeeds",
        //   this.$store.state.auth.user._id
        // );
        await this.$store.dispatch(
          "posts/getChannelPosts",
          this.selectedChannel._id
        );
      } else {
        await this.$store.dispatch("posts/savePost", { postId });

        await this.$store.dispatch(
          "posts/getChannelPosts",
          this.selectedChannel._id
        );
      }
    },
    async LikeCounts() {
      this.editModal = true;
      let res = await this.$store.dispatch("posts/LikeCounts", {
        postId: this.item._id,
      });
      this.thumblikes = res.data[0].likecount;
      this.lovelikes = res.data[0].lovecount;
      this.celebratelikes = res.data[0].celebratecount;
      this.supportlikes = res.data[0].supportcount;
      this.insightfullikes = res.data[0].insightfulcount;
      this.curioslikes = res.data[0].curioscount;
      this.getLikeUsers("all");
    },
    async getLikeUsers(type) {
      if (this.type == type) {
        this.limit += 10;
        this.offset += 10;
      } else {
        this.limit = 10;
        this.offset = 0;
      }
      let res = await this.$store.dispatch("posts/LikeCountUsers", {
        postId: this.item._id,
        type: type == "all" ? "" : type,
        limit: this.limit,
        offset: this.offset,
      });
      if (this.type == type) {
        this.users = [...this.users, res.data];
      } else {
        this.users = res.data;
      }
      if (type) {
        this.type = type;
      }
    },
  },
  computed: {
    name() {
      if (this.item._user != null) {
        return `${this.item._user.firstname} ${this.item._user.lastname}`;
      }
    },
    postTime() {
      const distanceInWordsToNow = require("date-fns/distance_in_words_to_now");
      return `${distanceInWordsToNow(this.item.createdAt)} ago`;
    },
    image() {
      return `${this.$imageURL}/${this.item.media[0]}`;
    },
    userImage() {
      return this.item.userImage && `${this.$imageURL}/${this.item.userImage}`;
    },
    profileImage() {
      return (
        this.item._profile.image &&
        `${this.$imageURL}/${this.item._profile.image}`
      );
    },
    ...mapState("channel", ["selectedChannel"]),
    ...mapState("auth", {
      userData: "user",
    }),

    // likedUserName() {
    //   return `${this.item.likes[0]._user.firstname} ${this.item.likes[0]._user.lastname}`;
    // },
    // likedUserImage() {
    //   return (
    //     this.item.likes[0]._user.userImage &&
    //     `${this.$imageURL}/${this.item.likes[0]._user.userImage}`
    //   );
    // },
    // isType(){
    //   return this.item.
    // }
  },
  async mounted() {
    // console.log(this.item._profile);
  },
};
</script>
<style scoped>
.postimght {
  max-height: 25rem;
  object-fit: cover;
  width: 100%;
}
.table-th-colorblue th {
  padding: 5px 0px !important;
  background-color: #830c81 !important;
  color: #fff !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f4e9f4;
}
</style>
